export const BUS_LIST_ITEM__ASK = 'g-list-item__ask'
export const BUS_LIST_ITEM__VISIBLE = 'g-list-item__visible'
export const BUS_LIST_ITEM__INVISIBLE = 'g-list-item__invisible'
export const BUS_LIST__VALUE_CHANGE = 'g-list__value_change'
export const BUS_LIST__REGISTER = 'g-list__register'
export const BUS_LIST__UNREGISTER = 'g-list__unregister'
export const FILTER_RESET = 0
export const FILTER_MATCHED = 1
export const FILTER_NOT_MATCHED = 2



// WEBPACK FOOTER //
// ./src/module/list/constants.js